import { createFileRoute } from '@tanstack/react-router'

import { ChatPage } from '../components/pages/chat/chat-page.tsx'

export const Route = createFileRoute('/chat')({
  component: ChatPage,
})
